import React from 'react'
import { useI18N } from '../../../libraries/i18n/hook'

interface RadioInputProps extends React.InputHTMLAttributes<HTMLInputElement> {}
interface RadioButtonProps extends RadioInputProps { icon?: React.ReactNode, fillType?: 'fill' | 'stroke', label?: string, labelPosition?: 'right' | 'bottom' }
const RadioButton: React.FC<RadioButtonProps> = ({ icon, label, labelPosition = 'right', fillType = 'fill', checked, disabled, ...rest}) => {
  const ref = React.useRef<HTMLInputElement>(null)
  const { t } = useI18N()

  React.useEffect(() => {
    if (ref.current) {
      ref.current.setCustomValidity('')
      ref.current.oninvalid = () => {
        ref.current!.setCustomValidity(t('error.select.min.an.option'))
      }
      ref.current.oninput = () => {
        ref.current!.setCustomValidity('')
      }
    }
  }, [rest.required])

  return (
    <label className={`
      relative bg-white border p-3 rounded-xl flex-1 flex gap-x-4 items-center w-full
      ${checked ? 'border-solid border-deep-green text-deep-green' : 'shadow-md' }
      ${labelPosition === 'bottom' ? 'flex-col gap-y-4' : 'justify-center'}
      ${disabled ? 'cursor-not-allowed bg-gray-100 opacity-70' : 'cursor-pointer'}
    `}>
      <input ref={ref} type='radio' {...rest} checked={ref.current?.checked} className='absolute opacity-0' disabled={disabled} />
      {icon && React.cloneElement(icon as React.ReactElement, { className: `${checked ? `${fillType}-deep-green` : `${fillType}-gray-200`}` })}
      {label && <span className='text-2xs sm:text-sm text-center flex items-center'>{label}</span>}
    </label>
  )
}

export default RadioButton
